import { Box } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import RestaurantItemSkeleton from './RestaurantItemSkeleton';

interface RestaurantListSkeletonProps {
}

const RestaurantListSkeleton: React.FC<RestaurantListSkeletonProps> = ({ }) => {
    return (
        <Box
            display={"grid"}
            gridTemplateColumns={{ xs: "repeat(1, minmax(0, 1fr))", sm: "repeat(2, minmax(0, 1fr))", md: "repeat(3, minmax(0, 1fr))" }}
            flexDirection={"row"}
            flexWrap={"wrap"}
            alignItems={"center"}
            gap={2}
            sx={{
                width: "100%",
                maxWidth: 'lg'
            }}>
            {_.map(new Array(3), (item, index) => (
                <RestaurantItemSkeleton key={`restaurant-skeleton-${index}`} />
            ))}
        </Box>
    )
}

export default RestaurantListSkeleton;